// EXPORT

export default {
	account: {
		screenComponent: "Account",
		url: "/account",
		viewComponent: "AppView"
	},
	cops: {
		screenComponent: "Cops",
		url: "/my-cops",
		viewComponent: "AppView"
	},
	dashboard: {
		screenComponent: "Dashboard",
		url: "/dashboard",
		viewComponent: "AppView"
	},
	forgotPassword: {
		screenComponent: "ForgotPassword",
		url: "/auth/forgot-password",
		viewComponent: "AuthView"
	},
	lists: {
		screenComponent: "Lists",
		url: "/my-lists",
		viewComponent: "AppView"
	},
	messages: {
		screenComponent: "Messages",
		url: "/messages/:messageId?",
		viewComponent: "AppView"
	},
	notFound: {
		screenComponent: "NotFound",
		url: "*",
		viewComponent: "AppView"
	},
	resendActivationCode: {
		screenComponent: "ResendActivationCode",
		url: "/auth/resend-activation-code",
		viewComponent: "AuthView"
	},
	reservation: {
		screenComponent: "Reservation",
		url: "/events/:eventId/reservation",
		viewComponent: "AppView"
	},
	signIn: {
		screenComponent: "SignIn",
		url: "/auth/sign-in",
		viewComponent: "AuthView"
	},
	signUp: {
		screenComponent: "SignUp",
		url: "/auth/sign-up",
		viewComponent: "AuthView"
	},
	storeRules: {
		screenComponent: "StoreRules",
		url: "/events/:eventId/store-rules",
		viewComponent: "AppView"
	}
};
